import type { INormalOfferPricesResponse } from 'shared/repositories/mortgage-subsidised-offers/entities/get_normal_offers_prices/NormalOfferPricesResponse';
import type { IEtazhiBlackFridayPricesData } from 'shared/types/etazhiBlackFriday';

export const mapResponse200 = (response: INormalOfferPricesResponse): IEtazhiBlackFridayPricesData => {
  return response.offerPrices as IEtazhiBlackFridayPricesData;
};
